//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    options: {
      default: function _default() {
        return [];
      }
    },
    value: {
      type: [Object, Array]
    }
  },
  methods: {
    hChange: function hChange(v) {
      var _this$$refs$c$getChec = this.$refs.c.getCheckedNodes()[0],
        value = _this$$refs$c$getChec.value,
        label = _this$$refs$c$getChec.label;
      this.$emit('input', {
        name: label,
        value: value
      });
    }
  }
};